var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hx-shadow-contianer" }, [
      _c("h1", { staticClass: "title" }, [_vm._v("页面走丢了~")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }